// 必填验证
export const required = (message = "required", trigger = "change") => {
  return {
    message,
    required: true,
    trigger
  };
};

required.change = message => required(message, "change");

required.blur = message => required(message, "blur");

required.both = message => required(message, "blur change");

export const lengthLimit = (
  message,
  trigger = "change",
  { min = "1", max } = {}
) => {
  if (max < min || max < 0 || min < 0) return {};
};

// 校验输入的 Qty 必须为数字且 >0
export const QtyValidateCheck = (rule, value, callback) => {
  if (!value) {
    return callback(new Error("Can not be empty"));
  }
  if (!Number.isInteger(value)) {
    callback(new Error("Please input number"));
  } else {
    if (value < 0) {
      callback(new Error("Must be a positive integer greater than 0"));
    } else {
      callback();
    }
  }
};

export const usersLimitValidateCheck = (rule, value, callback) => {
  if (!value) {
    return callback(new Error("Can not be empty"));
  }
  if (value.split(",").length > 50) {
    callback(new Error("Maximum number of users is 50"));
  } else {
    callback();
  }
};

export const mobileLimitValidateCheck = (rule, value, callback) => {
  if (!value) {
    return callback(new Error("Can not be empty"));
  }
  if (value.split(",").length > 50) {
    callback(new Error("Maximum number of mobile is 50"));
  } else {
    callback();
  }
};

export function commonRules() {
  return {
    required: {
      required: true,
      message: this.$t("Basic.required")
    },
    typeNumber: {
      type: "number",
      message: this.$t("Promotion.error_num")
    },
    price: {
      pattern: /^([1-9]\d*)(\.\d{1,2})?$|^0(\.\d{1,2})$/,
      message: this.$t("Promotion.error_pirce"),
      trigger: "blur"
    },
    // nonNegativePrice: {
    //   pattern: /^([1-9]\d*|0)(\.\d{1,2})?$/,
    //   message: this.$t("Promotion.error_non_negative"),
    //   trigger: "blur"
    // },
    percent: {
      pattern: /^([1-9]\d{0,1})$/,
      message: this.$t("Promotion.error_positive", { min: 1, max: 99 }),
      trigger: "blur"
    },
    // percent_1: {
    //   pattern: /^([1-9]\d{0,1})$/,
    //   message: this.$t("Promotion.error_positive", { min: 1, max: 99 }),
    //   trigger: "blur"
    // },
    nonNegativeInt: {
      pattern: /^([1-9]\d*|0)$/,
      message: this.$t("Promotion.error_non_negative_int"),
      trigger: "blur"
    },
    positiveInteger: {
      pattern: /^([1-9]\d*)$/,
      message: this.$t("Promotion.error_positive_Integer"),
      trigger: "blur"
    }
  };
}
